import { CheckCircle2, CircleAlert, Info, X } from "lucide-react";
import type { Feedback } from "../types";

type FeedbackToastProps = {
  feedback: Feedback;
  onClose: () => void;
};

const icons = {
  success: CheckCircle2,
  error: CircleAlert,
  info: Info,
};

export function FeedbackToast({ feedback, onClose }: FeedbackToastProps) {
  const Icon = icons[feedback.tone];
  return (
    <div className={`toast toast--${feedback.tone}`} role="status" aria-live="polite">
      <Icon aria-hidden="true" size={20} />
      <p>{feedback.message}</p>
      <button type="button" onClick={onClose} aria-label="Stäng meddelandet">
        <X aria-hidden="true" size={18} />
      </button>
    </div>
  );
}
